import styled from "styled-components";

export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #333;

  @media print {
    background-color: white;
    margin: 0;
    padding: 0;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #007bc6;

  h2 {
    color: #007bc6;
    margin: 0;
  }
`;

export const NotaFinal = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #007bc6;

  span {
    background-color: #007bc6;
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    margin-left: 10px;
  }
`;

export const CompetenciaItem = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  span {
    font-weight: 500;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 8px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${props => props.width}%;
  background-color: ${props => {
    if (props.color === 'success') return '#28a745';
    if (props.color === 'warning') return '#ffc107';
    return '#dc3545';
  }};
  border-radius: 10px;
  transition: width 0.3s ease;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.2) 50%,
      transparent 100%
    );
  }
`;

export const ComentarioItem = styled.div`
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;

  strong {
    color: #007bc6;
    display: block;
    margin-bottom: 5px;
  }

  p {
    margin: 0;
    color: #666;
    font-style: italic;
  }
`;

export const TextoRedacao = styled.div`
  line-height: 1.6;
  font-size: 16px;
  color: #333;

  p {
    margin-bottom: 15px;
    text-align: justify;
  }
`;

export const FeedbackGeral = styled.div`
  h1, h2, h3, h4, h5, h6 {
    color: #007bc6;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    line-height: 1.6;
    margin-bottom: 15px;
  }
`;

export const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  border: none;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 123, 198, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 123, 198, 0.6);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const FloatingButtonImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  ${FloatingButton}:hover & {
    transform: scale(1.1);
  }
`;

const bounce = `
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`;

const fadeInUp = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 40px, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`;

export const ChatNotification = styled.div`
  ${bounce}
  ${fadeInUp}
  position: fixed;
  bottom: 100px;
  right: 20px;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(0, 123, 198, 0.4);
  z-index: 999;
  max-width: 200px;
  text-align: center;
  animation: fadeInUp 0.5s ease-out, bounce 2s infinite;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 25px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #0056b3;
  }
`;

export const NotificationClose = styled.button`
  position: absolute;
  top: -5px;
  right: 5px;
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;